import React from "react";

const AddIcon = ({ style, color = "#4548C4", size = 20, strokeWidth = 1.8 }) =>
  <svg style={style} width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 4.1665V15.8332M4.16667 9.99984H15.8333" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
  </svg>;

export default AddIcon;

